export default abstract class NetworkRequestError extends Error {
  abstract getPublicId(): string | undefined;
  abstract isHandled(): boolean;
}
